import styled from 'styled-components'
import { typography, Media, color, spacing } from '../../style'

export const DemoCard = styled.div`
  width: 300px;
  height: 300px;
  background-color: ${color.grey};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: auto;
  ${Media.lessThan(Media.small)} {
    width: auto;
  }
  img {
    margin: ${spacing.large} 0;
  }
  button {
    font-size: ${typography.textSmall};
  }
`
export const ApplyForm = styled.div`
  width: 560px;
  margin: auto;
  fieldset {
    padding: 0;
    margin: ${spacing.large} 0;
    border: none;
  }
  input {
    width: 100%;
    height: 50px;
    line-height: 50px;
  }
  ${Media.lessThan(Media.small)} {
    input {
    }
    width: auto;
  }
`
export const VerifyCodeButton = styled.button`
  cursor: pointer;
  width: 35%;
  height: 50px;
  user-select: none;
  font-weight: bold;
  border-radius: 5px;
  background: ${(props) =>
    props.disabled ? '#3e4149' : `linear-gradient(to right, ${color.secondary}, ${color.primary})`};
  color: ${(props) => (props.disabled ? 'inherit' : 'white')};
  margin-left: 5%;
  padding: 0;
  border: 1px solid ${color.border};
  :active,
  :focus {
    outline: 0;
  }
  :disabled {
    cursor: not-allowed;
  }
`
